import { AspectRatio, VStack } from '@chakra-ui/react'
import Image from 'next/image'
import { Course } from '@/features/Courses/types'
import { logEvent } from '@/lib/stats'
import Link from 'next/link'
import Router from 'next/router'

interface Props {
  course: Course
}

function BundlePromoImage({ course }: Props): React.ReactElement | null {
  if (!course.bundlePromoImage) return null

  const handleClick = () => {
    logEvent({
      ga: {
        category: 'Course Detail-CTA',
        action: 'Click bundle promo',
        label: course.title,
      },
    })
    Router.push(course.bundlePromoLink || '/')
  }

  return (
    <VStack
      spacing={{
        base: 8,
        md: 10,
      }}
    >
      <Link href={course.bundlePromoLink || '/'} passHref>
        <a onClick={handleClick} style={{ width: '100%' }}>
          <AspectRatio as="figure" ratio={380 / 214}>
            <Image
              src={course.bundlePromoImage}
              alt={course.title}
              layout="fill"
              style={{
                borderRadius: '8px',
              }}
            />
          </AspectRatio>
        </a>
      </Link>
    </VStack>
  )
}

export default BundlePromoImage
